import { render, staticRenderFns } from "./FotorConfirm.vue?vue&type=template&id=634c8069&scoped=true"
import script from "./FotorConfirm.vue?vue&type=script&lang=js"
export * from "./FotorConfirm.vue?vue&type=script&lang=js"
import style0 from "./FotorConfirm.vue?vue&type=style&index=0&id=634c8069&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634c8069",
  null
  
)

export default component.exports